export const errorText = (error: any): string | undefined => {
	if (error === undefined || error === null) {
		return undefined
	}
	if (typeof error === 'string') {
		return error
	}
	return error.message ?? String(error)
}
